import { colors } from 'component-library/styles/colors';
import { css } from 'styled-components';

import { ShowOnProps, showOnStyles } from '../wrappers/ShowOn';

export const SERVICES = [
  { label: 'Advisor', to: '/advisor' },
  { label: 'Income', to: '/income' },
  { label: 'Investing', to: '/investing' },
  { label: 'Spending', to: '/spending' },
  { label: 'Benefits', to: '/benefits' },
];

export const MENU_ITEMS = [
  { label: 'Partner With Us', to: '/partners' },
  { label: 'About Us', to: '/about-us' },
  { label: 'Blog', to: '/advice' },
  { label: 'FAQ', to: '/faq' },
];

export const baseNavWrapperStyles = css<ShowOnProps>`
  background-color: #dbf0e7;
  border-bottom: 1px solid ${colors.navyBlue};
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 3;

  ${showOnStyles}
`;
